import template from './target.html';
import controller from './target.controller';
import './target.scss';

let targetComponent = {
  bindings: {},
  template,
  controller
};

export default targetComponent;



// WEBPACK FOOTER //
// ./client/app/components/target/target.component.js